<template>
  <el-tooltip effect="dark" content="作战地图" placement="bottom">
    <el-button class="d2-mr btn-text can-hover" type="text" @click="onGotoMap">
      <d2-icon name="map" style="font-size: 16px" />
    </el-button>
  </el-tooltip>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  methods: {
    onGotoMap () {
      this.$router.push({
        path: '/battle-map'
      })
    }
  }
}
</script>
